import React, { ReactNode } from 'react';
import { Inline } from '@contentful/rich-text-types';
import LinkWrapper from '@src/components/LinkWrapper';
import { isLocalUrl } from '@src/utils/url';
import styles from './RichTextHyperlink.module.scss';
import classNames from 'classnames';
import BoxIcon from '@src/elements/BoxIcon';

interface RichTextHyperlinkProps {
  node: Inline;
  children: ReactNode;
}

const RichTextHyperlink: React.FC<RichTextHyperlinkProps> = ({
  node,
  children
}) => {
  const openNewWindow = !isLocalUrl(node?.data?.uri);
  const isTelLink = node?.data?.uri?.includes('tel:');

  return (
    <span className={classNames(styles.richTextHyperlink)}>
      <LinkWrapper
        key={node?.data?.sys?.id}
        href={node?.data?.uri}
        openNewWindow={openNewWindow}
      >
        {children}
        {(openNewWindow || isTelLink) && (
          <span className={styles.iconWrapper}>
            <BoxIcon
              size="xs"
              name={openNewWindow && isTelLink ? 'phone' : 'link-external'}
            />
          </span>
        )}
      </LinkWrapper>
    </span>
  );
};

export default RichTextHyperlink;
